export const INSUFFICIENT_N = 5;